ACC.spsreturns = {
  currentRmdData: {},
  bindAll: function() {
    $(document).on('click', '.ph-radio_userselection', function() {
      $('.ph-submitsuccessmsg,.ph-newspsreturn_start,.ph-newspsreturn_search,.ph-newspsreturn_form,.ph-proformaclass,.ph-startnewreturnbutton,.ph-submitreturnbutton,.ph-forproformaupload_wrap').hide();

      if ($(this).val() === 'new') {
        $('.ph-returns_newstart').show();
        $('.ph-returns_existingstatus').hide();
        $('.ph-forproformauploaded_filename,.ph-forairwayuploaded_filename').html('');
        $('#uploadairwaybill,#uploadproforma,#fld1,#fld2,#fld3').val('');
      } else {
        $('.ph-returns_newstart').hide();
        $('.ph-returns_existingstatus').show();

        if ($('.ph-newspsreturn_search').find('.ph-rmdresultrow').length > 0) {
          $('.ph-newspsreturn_search').show();
        }

        ACC.spsreturns.showStartNewReturnButton();
      }
    });

    $('#rmdStatus').on('change', function() {
      ACC.spsreturns.validationRmdStatus();
    });

    $(document).on('click', '#searchorder', function(event) {
      event.preventDefault();
      $('.ph-startnewreturnbutton,.ph-proformaclass,.ph-exportxls,.ph-submitreturnbutton').hide();

      var validationStatus = ACC.spsreturns.validationRmdStatus();

      if (validationStatus === true) {
        ACC.spsreturns.getRmdList('search');
      }
    });
    $(document).on('click', '#startnowbutton', function() {
      ACC.spsreturns.getRmdList('start');
    });
    $(document).on('click', '#startnewreturnbutton', function() {
      var checkedRmdRowsData = [];

      if ($('.ph-newspsreturn_table:visible .ph-rmdrow_selection:checked').length > 0) {
        ACC.spsreturns.currentRmdData.forEach(function(rmd) {
          var inputRmd = $('.ph-newspsreturn_table:visible #rmdinput' + rmd.rmdNumber + ':checked').val();

          if (rmd.rmdNumber === inputRmd) {
            checkedRmdRowsData.push(rmd);
          }
        });
      }

      $('.ph-newspsreturn_form').show();
      $('.ph-newspsreturn_start,.ph-startnewreturnbutton').hide();
      ACC.spsreturns.showSelectedRmdRows(checkedRmdRowsData);
    });

    $(document).on('click', '.ph-newspsreturn_rmds .ph-newspsreturn_table .ph-rmdrow_selection', function() {
      ACC.spsreturns.showStartNewReturnButton();
    });
    $(document).on('click', '.ph-newspsreturn_search .ph-newspsreturn_table .ph-rmdrow_radio', function() {
      $('.ph-proformaclass').show();
    });
    $(document).on('click', '.sameitemno,.sameitemyes', function() {
      var $rmdRow = $(this).parents('.ph-rmdresultrow');

      if ($(this).is(':checked') && $(this).val() === 'false') {
        $rmdRow.find('.ph-otheriteminput_wrap,.ph-returneditem_number_msg').show();
      } else {
        $rmdRow.find('.ph-otheriteminput_wrap,.ph-returneditem_number_msg').hide();
      }
    });
    $(document).on('keyup blur', '.ph-otheriteminput', function() {
      this.value = this.value.replace(/[^0-9]/g, '');

      if ($(this).val() === '') {
        $(this).parent().find('.ph-icon-search').addClass('hidden');
        $(this).parent().addClass('ph-form_field_error');
      } else {
        $(this).parent().find('.ph-icon-search').removeClass('hidden');
      }
    });
    $(document).on('click', '.ph-otheriteminput_wrap .ph-icon-search', function() {
      var $rmdRow = $(this).parents('.ph-rmdresultrow'),
          otheriteminputVal = $.trim($rmdRow.find('.ph-otheriteminput').val());

      if (otheriteminputVal !== '' && otheriteminputVal.length === 12) {
        ACC.spsreturns.differentItemCodeSearch(otheriteminputVal, $rmdRow);
      }
    });
    $(document).on('click', '.ph-exportxls', function() {
      if ($('.ph-radio_userselection:checked').val() === 'search') {
        var dataList = [],
            fileNameDownload = 'spReturnsOverview_' + Date.now() + '.xls';

        $('.ph-newspsreturn_search table tr').each(function() {
          var items = [],
              $trRow = $(this);

          $trRow.find('td:visible,th:visible').each(function() {
            if ($(this).attr('data-column') !== 'radio' && $(this).attr('data-column') !== 'checkbox') {
              items.push($(this).text().trim());
            }
          });
          dataList.push(items);
        });
        ACC.spsreturns.xlsDownload(dataList, fileNameDownload);
      }
    });
    $(document).on('click', '.ph-openrmdexportxls', function() {
      if ($('.ph-radio_userselection:checked').val() === 'new') {
        var dataList = [],
            fileNameDownload = 'openRmdList_' + Date.now() + '.xls';

        $('.ph-newspsreturn_rmds table tr').each(function() {
          var items = [],
              $trRow = $(this);

          $trRow.find('td:visible,th:visible').each(function() {
            if ($(this).attr('data-column') !== 'checkbox') {
              items.push($(this).text().trim());
            }
          });
          dataList.push(items);
        });
        ACC.spsreturns.xlsDownload(dataList, fileNameDownload);
      }
    });
    $(document).on('click', '#proforma', function() {
      if ($('.ph-radio_userselection:checked').val() === 'search') {
        ACC.spsreturns.proformaGeneration2();
      } else {
        ACC.spsreturns.proformaGeneration();
      }
    });
    $(document).on('click', '#submitreturnbtn', function() {
      ACC.spsreturns.finalReturnSubmit();
    });
    $(document).on('click', '.ph-uploadairwaybill_btn', function() {
      $('#uploadairwaybill').trigger('click');
    });
    $(document).on('change', '#uploadairwaybill', function() {
      $('.ph-forairwayuploaded_filename').html('');
      $('.airwaybill_formatError_msg,.airwaybill_sizeerror_msg,.ph-forairwayupload').hide();
      ACC.spsreturns.uploadairwaybillCheck(this);
    });
    $(document).on('click', '.ph-uploadproforma_btn', function() {
      $('#uploadproforma').trigger('click');
    });
    $(document).on('change', '#uploadproforma', function() {
      $('.ph-forproformauploaded_filename').html('');
      $('.proforma_formatError_msg,.proforma_sizeerror_msg,.ph-forproformaupload').hide();
      ACC.spsreturns.uploadProformaCheck(this);
    });
    $(document).on('blur', '.ph-newspsreturn_form .ph-otheriteminput:visible', function() {
      if ($.trim($(this).val()) === '' || $.trim($(this).val()).length !== 12) {
        $(this).parents('.ph-otheriteminput_wrap').addClass('ph-form_field_error');
        $(this).parents('.ph-otheriteminput_wrap').find('.ph-itemcode-inputerror').removeClass('hidden');
      } else {
        $(this).parents('.ph-otheriteminput_wrap').removeClass('ph-form_field_error');
        $(this).parents('.ph-otheriteminput_wrap').find('.ph-itemcode-inputerror').addClass('hidden');
      }
    });
  },
  uploadairwaybillCheck: function($this) {
    var file = $this.files[0];

    if (file) {
      var fileName = $.trim(file.name),
          fileExtension = fileName.split('.').pop().toLowerCase(),
          allowedExtensionsString = $.trim($('.airwaybill_uploadformat').html()).toLowerCase();
      var allowedExtensions = allowedExtensionsString.split(','),
          maxSizeMb = $('.airwaybill_uploadsize').html(),
          maxSizeBytes = maxSizeMb * 1024 * 1024;

      if ($.inArray(fileExtension, allowedExtensions) === -1) {
        $('.ph-forairwayupload').html($('.airwayupload2').html()).show();
        $('.airwaybill_formatError_msg').show();
        $($this).parents('.ph-form__fieldwrap').addClass('ph-form_field_error');
        $($this).val('');
      } else if (file.size > maxSizeBytes) {
        $('.ph-forairwayupload').html($('.airwayupload2').html()).show();
        $('.airwaybill_sizeerror_msg').show();
        $($this).parents('.ph-form__fieldwrap').addClass('ph-form_field_error');
        $($this).val('');
      } else {
        $('.ph-forairwayuploaded_filename').html(fileName);
        $($this).parents('.ph-form__fieldwrap').removeClass('ph-form_field_error');
      }
    }
  },
  uploadProformaCheck: function($this) {
    var file = $this.files[0];

    if (file) {
      var fileName = $.trim(file.name),
          fileExtension = fileName.split('.').pop().toLowerCase(),
          allowedExtensionsString = $.trim($('.proforma_uploadformat').html()).toLowerCase();
      var allowedExtensions = allowedExtensionsString.split(','),
          maxSizeMb = $('.proforma_uploadsize').html(),
          maxSizeBytes = maxSizeMb * 1024 * 1024;

      if ($.inArray(fileExtension, allowedExtensions) === -1) {
        $('.ph-forproformaupload').html($('.proformaupload2').html()).show();
        $('.proforma_formatError_msg').show();
        $($this).parents('.ph-form__fieldwrap').addClass('ph-form_field_error');
        $($this).val('');
      } else if (file.size > maxSizeBytes) {
        $('.ph-forproformaupload').html($('.proformaupload2').html()).show();
        $('.proforma_sizeerror_msg').show();
        $($this).parents('.ph-form__fieldwrap').addClass('ph-form_field_error');
        $($this).val('');
      } else {
        $('.ph-forproformauploaded_filename').html(fileName);
        $($this).parents('.ph-form__fieldwrap').removeClass('ph-form_field_error');
      }
    }
  },
  showStartNewReturnButton: function() {
    if ($('.ph-newspsreturn_rmds .ph-newspsreturn_table:visible .ph-rmdrow_selection:checked').length > 0) {
      $('.ph-startnewreturnbutton').show();
    } else {
      $('.ph-startnewreturnbutton').hide();
    }
  },
  showSelectedRmdRows: function(checkedRmdRowsData) {
    var rows = ACC.spsreturns.generateRmdRows($('.ph-newspsreturn_form'), checkedRmdRowsData);

    ACC.spsreturns.checkedRmdTable($('.ph-newspsreturn_form'), rows);
    $('.ph-proformaclass').show();
  },
  getStoreDateFormat: function() {
    var storeDateFormat = $.trim($('.ph-dateFormat').text());

    return storeDateFormat.toLowerCase().replace('yyyy', 'yy');
  },
  dateTobeSent: function(inputDateValue) {
    var formattedDate = $.datepicker.parseDate(ACC.spsreturns.getStoreDateFormat(), inputDateValue);

    return $.datepicker.formatDate('mm/dd/yy', formattedDate);
  },
  datePickerSetup: function(mode, spsfromDateId, spstoDateId) {
    var todayDate = new Date(),
        dateDiffWindow = 90,
        storeDateFormat = ACC.spsreturns.getStoreDateFormat();


    $(spstoDateId).val($.datepicker.formatDate(storeDateFormat, new Date()));

    if (mode === 'start') {
      dateDiffWindow = 180;
    }

    if ($('.spsReturnDateRange1').length > 0 && mode === 'start') {
      dateDiffWindow = parseInt($('.spsReturnDateRange1').text(), 10);
    }

    if ($('.spsReturnDateRange2').length > 0 && mode === 'search') {
      dateDiffWindow = parseInt($('.spsReturnDateRange2').text(), 10);
    }

    $(spsfromDateId).datepicker({
      maxDate: new Date(todayDate.setDate(todayDate.getDate())),
      dateFormat: storeDateFormat,
      onSelect: function() {
        var toDate = $(spsfromDateId).datepicker('getDate');
        /* eslint-disable no-ternary */
        var setDt = toDate.addDays(dateDiffWindow) > todayDate ? todayDate : toDate.addDays(dateDiffWindow);

        /* eslint-enable no-ternary */
        $(spstoDateId).datepicker('option', 'minDate', toDate);
        $(spstoDateId).datepicker('setDate', setDt);
        $(spstoDateId).datepicker('option', 'maxDate', setDt);
        $(spstoDateId).val($.datepicker.formatDate(storeDateFormat, setDt));
        $(this).blur();
      },
      endDate: 'today'
    });
    $(spstoDateId).datepicker({
      maxDate: new Date(todayDate.setDate(todayDate.getDate())),
      dateFormat: storeDateFormat,
      onSelect: function() {
        $(spsfromDateId).datepicker('option', 'maxDate', new Date(todayDate.setDate(todayDate.getDate())));
        $(this).blur();
      },
      endDate: 'today'
    });

    var rangecustomStart = $(spstoDateId).datepicker('getDate');

    $(spsfromDateId).val($.datepicker.formatDate(storeDateFormat, rangecustomStart.removeDays(dateDiffWindow)));
  },
  sortingStatusOptions: function() {
    var sortedOptions = [];

    $.each($('#rmdStatus option'), function() {
      var currentText = $(this).text();

      if ($(this).val() === '') {
        currentText = '0:' + $(this).text();
      }

      sortedOptions.push(currentText + '||' + $(this).val());
    });
    sortedOptions.sort();
    $('#rmdStatus').html('');
    sortedOptions.forEach(function(newopt) {
      var newoptn = $.trim(newopt).split('||'),
          newoptnSplited = $.trim(newoptn[0]).split(':'),
          decidedOptTxt = newoptnSplited[0];

      if (newoptnSplited[1]) {
        decidedOptTxt = newoptnSplited[1];
      }

      $('#rmdStatus').append('<option value=\'' + newoptn[1] + '\'>' + decidedOptTxt + '</option>');
    });
    $('#rmdStatus').selectBox('refresh');
  },
  validationRmdStatus: function() {
    var validationStatus = true,
        rmdStatusText = $('#rmdStatus option:selected').val();

    if ($.trim(rmdStatusText) === '' || rmdStatusText === null) {
      $('#rmdStatus').parents('.form_field-input').addClass('form_field_error ph-form_field_error');
      validationStatus = false;
    } else {
      $('#rmdStatus').parents('.form_field-input').removeClass('form_field_error ph-form_field_error');
    }

    if ($('#spsfromDate2').val() === '' || $('#spstoDate2').val() === '') {
      validationStatus = false;
    }

    return validationStatus;
  },
  linkFormation: function(key, valueInput, rmd) {
    var value = valueInput,
        hrefvalue = '';

    if (key === 'confirmationNumber') {
      hrefvalue = ACC.config.contextPath + '/my-account/searchOrderInit/?orderCode=' + rmd.confirmationNumber;
      value = '<a target="_blank" href="' + hrefvalue + '">' + value + '</a>';
    }

    if (key === 'rmdNumber') {
      hrefvalue = ACC.config.contextPath + '/my-account/orders/rmdDownlaodPdf?rmdNumber=' + rmd.rmdNumber + '&orderNumber=' + rmd.confirmationNumber;
      value = '<a target="_blank" href="' + hrefvalue + '">' + value + '</a>';
    }

    return value;
  },
  newcustomrowitem: function(key, value, rmd) {
    var returnValue = value;

    if (key === 'serialNumber') {
      returnValue = '<input type="text" name="serialinput" class="ph-serialinput" id="serialinput' + rmd.rmdNumber + '">';
    }

    if (key === 'isSameItem') {
      returnValue = $('.ph-form__customfieldwrap').html();
      returnValue = returnValue.replaceAll('{n}', rmd.rmdNumber);
    }

    if (key === 'checkbox' && $('#radio_startnewreturn').val() === 'new') {
      returnValue = '<label class=" ph-checkboxcontainer ph-float-left"><input id="rmdinput' + rmd.rmdNumber + '" name="rmdrow_checkbox" class="ph-rmdrow_checkbox ph-rmdrow_selection" type="checkbox" value="' + rmd.rmdNumber + '"></label>';
    }

    if (key === 'deliveryItemNumber') {
      returnValue = parseInt(rmd.deliveryItemNumber, 10);
    }

    return returnValue;
  },
  generateRmdRows: function($rmdTable, responseData) {
    var rows = '';

    if (responseData.length >= 100) {
      $('.ph-openrmd_searchlimit').show();
    } else {
      $('.ph-openrmd_searchlimit').hide();
    }

    if (responseData.length > 0) {
      $('.ph-openrmd_export').show();
      ACC.spsreturns.currentRmdData = responseData;
      responseData.forEach(function(rmd) {
        var row = '<tr class="ph-rmdresultrow" data-origin="' + rmd.materialCountryOfOrigin + '" data-rso="' + rmd.rsoNumber + '" id="rmdresultrow' + rmd.rmdNumber + '">';

        $.each($rmdTable.find('tr th'), function() {
          var key = $(this).attr('data-column'),
              value = ACC.spsreturns.hasValue(rmd, key);

          if (key === 'radio' && $.trim($('#rmdStatusWrapper:visible select').val()) === 'returninprogress') {
            value = '<label data-invoiceurl="' + rmd.proformaInvoiceUrl + '" class="ph-radiocontainer ph-float-left" ><input name="rmdrow_radio" class="ph-rmdrow_radio ph-rmdrow_selection" type="radio" value="' + rmd.rmdNumber + '"><span class="ph-checkmark"></span></label>';
          }

          if (key === 'rmdStatus') {
            value = ACC.spsreturns.localizedStatus(value);
          }

          value = ACC.spsreturns.linkFormation(key, value, rmd);
          value = ACC.spsreturns.newcustomrowitem(key, value, rmd);

          row = row + ('<td data-column="' + key + '" class="ph-column_' + key + '">' + value + '</td>');
        });

        rows = rows + (row + '</tr>');
      });
    } else {
      $('.ph-openrmd_export').hide();
    }

    return rows;
  },
  checkedRmdTable: function($rmdTable, rows) {
    if (rows) {
      $rmdTable.find('tbody').html(rows);
    } else {
      var emptyrow = '<tr><td colspan="7">' + $('.norecords').html() + '</td></tr>';

      $rmdTable.find('tbody').html(emptyrow);
    }

    $rmdTable.show();
  },
  generateRmdTable: function($rmdTable, rows) {
    if (rows) {
      $rmdTable.find('tbody').html(rows);
      $('.ph-returns_existingstatus:visible .ph-exportxls').show();
    } else {
      var emptyrow = '<tr><td colspan="7">' + $('.norecords').html() + '</td></tr>';

      $rmdTable.find('tbody').html(emptyrow);
    }

    $rmdTable.show();

    if ($rmdTable.find('.ph-rmdrow_radio').length > 0) {
      $('.ph-spsradiolabel-row,.ph-column_radio').show();
    } else {
      $('.ph-spsradiolabel-row,.ph-column_radio').hide();
    }

    if ($rmdTable.find('.ph-rmdrow_checkbox').length > 0) {
      $('.ph-spscheckboxlabel-row,.ph-column_checkbox').show();
    }
  },
  getRmdList: function(mode) {
    var rmdStatusText = $('#rmdStatus option:selected').val(),
        spstoDate = $('#spstoDate2').val(),
        spsfromDate = $('#spsfromDate2').val(),
        $rmdTable = $('.ph-newspsreturn_search'),
        orderCategoryType = '';

    if (mode === 'start') {
      rmdStatusText = 'returnnotstarted,overduereturn';
      spstoDate = $('#spstoDate1').val();
      spsfromDate = $('#spsfromDate1').val();
      $rmdTable = $('.ph-newspsreturn_start');
      $('.ph-returns_newstart').hide();
    }

    if ($('.ph-radio_userselection:checked').val() === 'new') {
      orderCategoryType = 'openRMD';
    }

    $('.ph-spinnerorder').show();
    $.ajax({
      url: ACC.config.contextPath + '/my-account/spReturnStatus',
      data: {
        rmdStatus: rmdStatusText,
        spsfromDate: spsfromDate,
        spstoDate: spstoDate,
        orderCategoryType: orderCategoryType
      },
      type: 'GET',
      datatype: 'json',
      success: function(responseData) {
        $('.ph-spinnerorder').hide();

        var rows = ACC.spsreturns.generateRmdRows($rmdTable, responseData);

        ACC.spsreturns.generateRmdTable($rmdTable, rows);
      },
      error: function() {
        $('.ph-spinnerorder').hide();
      }
    });
  },
  hasValue: function(rmd, field) {
    var returnVal = '';

    if (rmd[field]) {
      returnVal = rmd[field];
    }

    return returnVal;
  },
  localizedStatus: function(val) {
    var locStatus = val;

    $.each($('#rmdStatus option'), function() {
      if ($(this).val() === val) {
        locStatus = $(this).text();
      }
    });

    return locStatus;
  },
  xlsDownload: function(dataList, fileNameDownload) {
    $('.ph-spinnerorder').show();
    $.ajax({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      type: 'POST',
      url: ACC.config.contextPath + '/my-account/spReturnsExcelOverView',
      data: JSON.stringify(dataList),
      xhrFields: {
        responseType: 'blob'
      },
      success: function(blobResponse) {
        $('.ph-spinnerorder').hide();

        var url = window.URL.createObjectURL(blobResponse);
        var a = document.createElement('a');

        a.href = url;
        a.download = fileNameDownload;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error: function() {
        $('.ph-spinnerorder').hide();
      }
    });
  },
  materialCodeSearchResponse: function(response, $rmdRow) {
    if (response && response[0]) {
      var returnedMaterialNumber = $.trim($('.returnedMaterialNumber').html()),
          returnedMaterialDescription = $.trim($('.returnedMaterialDescription').html()),
          returnedMaterialCountryOfOrigin = $.trim($('.returnedMaterialCountryOfOrigin').html()),
          itemMaterial = '',
          itemDesc = '',
          itemOrigin = '',
          alternateItemDetails = response[0];

      if (alternateItemDetails.materialNumber) {
        itemMaterial = '<span>' + returnedMaterialNumber + alternateItemDetails.materialNumber + '</span>';
        $rmdRow.find('.rmnumber').val(alternateItemDetails.materialNumber);
      }

      if (alternateItemDetails.materialDescription) {
        itemDesc = '<span>' + returnedMaterialDescription + alternateItemDetails.materialDescription + '</span>';
        $rmdRow.find('.rmdesc').val(alternateItemDetails.materialDescription);
      }

      if (alternateItemDetails.materialCountryOfOrigin) {
        itemOrigin = '<span>' + returnedMaterialCountryOfOrigin + alternateItemDetails.materialCountryOfOrigin + '</span>';
        $rmdRow.find('.rmcoo').val(alternateItemDetails.materialCountryOfOrigin);
      }

      $rmdRow.find('.ph-column_confirmationNumber').append('<span class="ph-returneditem_number_msg">' + itemMaterial + itemDesc + itemOrigin + '</span>');
    }
  },
  differentItemCodeSearch: function(itemCodeValue, $rmdRow) {
    $rmdRow.find('.ph-returneditem_number_msg').remove();
    $('.ph-spinnerorder').show();
    $.ajax({
      url: ACC.config.contextPath + '/my-account/spsMaterialDetails',
      data: {
        materialNumber: itemCodeValue
      },
      type: 'POST',
      datatype: 'json',
      success: function(response) {
        $('.ph-spinnerorder').hide();
        ACC.spsreturns.materialCodeSearchResponse(response, $rmdRow);
      },
      error: function() {
        $('.ph-spinnerorder').hide();
      }
    });
  },
  newReturnFormValidation: function(pageType) {
    var validationStatus = true;

    $('.ph-newspsreturn_form .required_fld:visible').each(function() {
      if ($(this).val() === '') {
        $(this).parents('.ph-form__fieldwrap').addClass('ph-form_field_error');
        validationStatus = false;
      } else {
        $(this).parents('.ph-form__fieldwrap').removeClass('ph-form_field_error');
      }
    });

    if (pageType !== 'proforma' && $('#uploadairwaybill').val() === '') {
      validationStatus = false;
      $('.ph-forairwayupload_wrap').addClass('ph-form_field_error');
      $('.ph-forairwayupload').html($('.airwayupload1').html()).show();
    } else {
      $('.ph-forairwayupload_wrap').removeClass('ph-form_field_error');
      $('.ph-forairwayupload').hide();
    }

    if (pageType !== 'proforma' && $('#uploadproforma').val() === '') {
      validationStatus = false;
      $('.ph-forproformaupload_wrap').addClass('ph-form_field_error');
      $('.ph-forproformaupload').html($('.proformaupload1').html()).show();
    } else {
      $('.ph-forproformaupload_wrap').removeClass('ph-form_field_error');
      $('.ph-forproformaupload').hide();
    }

    $('.ph-newspsreturn_form .ph-otheriteminput:visible').each(function() {
      if ($.trim($(this).val()) === '' || $.trim($(this).val()).length !== 12) {
        $(this).parents('.ph-otheriteminput_wrap').addClass('ph-form_field_error');
        $(this).parents('.ph-otheriteminput_wrap').find('.ph-itemcode-inputerror').removeClass('hidden');
        validationStatus = false;
      } else {
        $(this).parents('.ph-otheriteminput_wrap').removeClass('ph-form_field_error');
        $(this).parents('.ph-otheriteminput_wrap').find('.ph-itemcode-inputerror').addClass('hidden');
      }
    });

    return validationStatus;
  },
  selectedRowsItemValues: function(pageType) {
    var items = [];

    $('.ph-newspsreturn_rmds table.ph-newspsreturn_table tr.ph-rmdresultrow:visible').each(function() {
      var $row = $(this),
          rmdNo = $row.find('.ph-column_rmdNumber a').text().trim(),
          isSameItemRow = $row.find('input[name="sameitem' + rmdNo + '"]:checked').val(),
          item = {
            rmdNo: rmdNo,
            orderNo: $row.find('.ph-column_confirmationNumber a').text().trim(),
            orderDate: $row.find('.ph-column_orderDate').text().trim(),
            serialNo: $row.find('.ph-column_serialNumber input.ph-serialinput').val().trim(),
            rsoNumber: $.trim($row.attr('data-rso')),
            itemNo: $row.find('.ph-column_deliveryItemNumber').text().trim(),
            description: $row.find('.ph-column_materialDescription').text().trim(),
            countryOfOrigin: $.trim($row.attr('data-origin')),
            isSameItem: isSameItemRow === 'true'
          };

      if (isSameItemRow === 'false' && $row.find('.ph-otheriteminput').length > 0) {
        if (pageType === 'invoice') {
          item.itemNo = $.trim($row.find('.rmnumber').val());
          item.description = $.trim($row.find('.rmdesc').val());
          item.countryOfOrigin = $.trim($row.find('.rmcoo').val());
        } else {
          item.altItemNo = $.trim($row.find('.rmnumber').val());
          item.altDescription = $.trim($row.find('.rmdesc').val());
          item.altCoo = $.trim($row.find('.rmcoo').val());
        }
      }

      items.push(item);
    });

    return items;
  },
  proformaGeneration2: function() {
    var invoiceurl = $('.ph-rmdrow_radio:checked').parent().attr('data-invoiceurl');

    if (invoiceurl && invoiceurl !== 'undefined') {
      window.open(invoiceurl, '_blank');
    }
  },
  proformaGeneration: function() {
    var carrier = $('#fld1').val(),
        airwayBill = $('#fld2').val(),
        invoiceNumber = $('#fld3').val();

    if (ACC.spsreturns.newReturnFormValidation('proforma')) {
      $('.ph-spinnerorder').show();
      $.ajax({
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        type: 'POST',
        url: ACC.config.contextPath + '/my-account/generateProformaInvoice',
        data: JSON.stringify({
          carrier: carrier,
          airwayBill: airwayBill,
          invoiceNumber: invoiceNumber,
          items: ACC.spsreturns.selectedRowsItemValues('invoice')
        }),
        xhrFields: {
          responseType: 'blob'
        },
        success: function(blobResponse) {
          $('.ph-proformaclass').hide();
          $('.ph-submitreturnbutton,.ph-forproformaupload_wrap').show();
          $('.ph-spinnerorder').hide();
          ACC.spsreturns.proformaDownload(blobResponse, invoiceNumber);
        },
        error: function() {
          $('.ph-spinnerorder').hide();
        }
      });
    } else if ($('.ph-form_field_error:visible').length > 0) {
      $('html, body').animate({
        scrollTop: $('.ph-form_field_error:visible').offset().top - 50
      }, 'slow');
    }
  },
  finalReturnSubmit: function() {
    var carrier = $('#fld1').val(),
        airwayBill = $('#fld2').val(),
        invoiceNumber = $('#fld3').val();

    if (ACC.spsreturns.newReturnFormValidation('returnsubmit')) {
      var formData = new FormData();

      formData.append('carrier', carrier);
      formData.append('airwayBill', airwayBill);
      formData.append('invoiceNumber', invoiceNumber);
      formData.append('items', JSON.stringify(ACC.spsreturns.selectedRowsItemValues('submit')));

      var fileInput = $('#uploadairwaybill')[0],
          file = fileInput.files[0],
          fileInputInvoice = $('#uploadproforma')[0],
          fileInvoice = fileInputInvoice.files[0];

      formData.append('uploadairwaybill', file);
      formData.append('proformaInvoiceDoc', fileInvoice);


      $('.ph-spinnerorder').show();
      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/my-account/submitNewReturn',
        data: formData,
        processData: false,
        contentType: false,
        success: function() {
          $('.ph-spinnerorder').hide();
          $('.startnewreturnbutton,.ph-proformaclass,.ph-submitreturnbutton,.ph-newspsreturn_form').hide();
          $('.ph-submitsuccessmsg').show();
        },
        error: function() {
          $('.ph-spinnerorder').hide();
        }
      });
    } else if ($('.ph-form_field_error:visible').length > 0) {
      $('html, body').animate({
        scrollTop: $('.ph-form_field_error:visible').offset().top - 50
      }, 'slow');
    }
  },
  proformaDownload: function(blobResponse, invoiceNumber) {
    var url = window.URL.createObjectURL(blobResponse);
    var a = document.createElement('a');

    a.href = url;
    a.download = 'proformaInvoice_' + invoiceNumber + '_' + Date.now() + '.xlsx';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  }
};

$(document).ready(function() {
  /* eslint-disable no-extend-native */
  Date.prototype.removeDays = function(days) {
    /* eslint-enable no-extend-native */
    var date = new Date(this.valueOf());

    date.setDate(date.getDate() - days);

    return date;
  };

  if ($('.ph-newspsreturnpage').length > 0) {
    ACC.spsreturns.sortingStatusOptions();
    ACC.spsreturns.bindAll();
    ACC.datePicker.setDatePickerLanguage();
    ACC.spsreturns.datePickerSetup('start', '#spsfromDate1', '#spstoDate1');
    ACC.spsreturns.datePickerSetup('search', '#spsfromDate2', '#spstoDate2');

    $(document).on('click', '.ph-calendaricon', function() {
      $(this).parent().parent().find('input.hasDatepicker').datepicker('show');
    });
  }
});

